export default __webpack_public_path__ + "static/char-54-0db5f389347a22bc802f6e638be7c4a8.gif";